import { gql } from '@apollo/client';
import {
  USER_COLLECTION_ADD_START,
  USER_COLLECTION_ADD_SUCCESS,
  USER_COLLECTION_ADD_ERROR,
} from 'constants/index';
import addItemToCollection from './addItemToCollection';

const MUTATION = {
  ADD_COLLECTION: gql`
    mutation AddCollection($name: String, $description: String, $visibility: CollectionVisibility) {
      AddCollection(name: $name, description: $description, visibility: $visibility) {
        id
        name
        description
        safe_description
        created_at
        visibility
        items_count {
          books
          people
          contents
          total
        }
      }
    }
  `,
};

export default function addCollection(params) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: USER_COLLECTION_ADD_START,
      payload: params,
    });

    try {
      const { data, errors } = await client.mutate({
        mutation: MUTATION.ADD_COLLECTION,
        variables: params,
      });

      if (errors && errors.length > 0) {
        dispatch({
          type: USER_COLLECTION_ADD_ERROR,
          payload: {
            errors: errors[0].graphQLErrors,
          },
        });
      } else {
        dispatch({
          type: USER_COLLECTION_ADD_SUCCESS,
          payload: { collection: data.AddCollection },
        });

        if (params.itemId && params.itemType) {
          // Add the initial item to the collection
          dispatch(
            addItemToCollection({
              id: data.AddCollection.id,
              itemId: params.itemId,
              itemType: params.itemType,
            }),
          );
        }
      }
    } catch (error) {
      dispatch({
        type: USER_COLLECTION_ADD_ERROR,
        payload: {
          errors: error.graphQLErrors,
        },
      });
    }
  };
}
